import React, { useMemo } from "react";
import { string } from "prop-types";

const iconBaseUrl = "/media/file-icons/";

type FileIconProps = {
  type: string;
  filename: string;
};

export const FileIcon = (props: FileIconProps) => {
  // Use props.type directly with fallback
  const type = props.type || "unknown";

  // Calculate src using useMemo to avoid state management
  const src = useMemo(() => {
    switch (type) {
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return iconBaseUrl + "excel.svg";
      case "image/png":
        return iconBaseUrl + "png.svg";
      case "image/jpeg":
        return iconBaseUrl + "jpg.svg";
      case "text/csv":
        return iconBaseUrl + "csv.svg";
      case "unknown":
      default:
        return iconBaseUrl + "unknown.svg";
    }
  }, [type]);

  return (
    <img
      src={src}
      alt={type}
      width={5000}
      height={5000}
      style={{
        maxWidth: "100%",
        height: "auto",
      }}
    />
  );
};

FileIcon.propTypes = {
  type: string.isRequired,
  filename: string.isRequired,
};
